import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import "../../styles/fxttrade.css";
import { fetchUserData } from "../../utils/tradeLogic";
import Trading from "../stocks/Trading";
import StartTrade from "./StartTrade";

const Trade = ({ user, accountBalances }) => {
  const [userRole, setUserRole] = useState("");
  const [hasActiveTrade, setHasActiveTrade] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      const data = await fetchUserData(user);
      if (data) {
        setUserRole(data.role);
        setHasActiveTrade(!!data.userData.activeTrade);
      }
      setIsLoading(false);
    };
    loadUser();
  }, [user]);

  const isAdmin = userRole === "admin";
  const isInvestor = userRole === "investor";

  return (
    <div className="fxt-trade-container" id="transfer">
      {isLoading ? (
        <div className="loading-container">
          <ClipLoader color="#D4292A" size={100} />
          <div className="center">
            Please wait, loading your account details...
          </div>
        </div>
      ) : isAdmin ? (
        <div className="admin-restriction">
          <div className="admin-restriction-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
              />
            </svg>
          </div>
          <div className="admin-restriction-content">
            <h2>Access Restricted</h2>
            <p>
              Admins cannot trade for security reasons. Your account has
              administrative privileges that prevent trading activity.
            </p>

            <div className="info-badge">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                />
              </svg>
              Security Protocol Active
            </div>
          </div>
        </div>
      ) : (isInvestor && hasActiveTrade) ? (
        <div>
          <Trading user={user} />
        </div>
      ) : (
        <StartTrade user={user} balance={accountBalances} />
      )}
    </div>
  );
};

export default Trade;
